export const NUMBER_OR_EMPTY_STRING = /^(\s*|\d+)$/ // accepts number or empty string